/**
 * 
 * Filters that we need: 
 * - network
 * - neighborhood
 * - 
 * 
 * */

export interface ISchoolFilterList {
    category: string;
    options: string[];
}

export interface ISchoolSearchEpiConfiguration {
    filters: string[]; // these are generated from 
}

// example object. these need to all be passed in from epi. We can also default them here and merge as necessary if it's easier.
export const EpiSettings = {
    environment: 'dev',
    googleMapsKey:  'AIzaSyDlX-D756GwzMD1yCzusjMfZPRYGb663Tc',// CPS

    // Which components to display
    components: {
        map: true,
        prekSearch: true,
        cpsSearch: true,
        viewMode: 'cards',
        // This is a big list. we can either take in all of the possible fields as an object with enabled / disabled, or field names as an array
        cardFields: {
            name: true,
            address: true,
            neighboorhood: false
        },
        // Or
        cardFields2: [
            'name',
            'address',
        ]
    },

    
    // Functions that can be defined in epi. These signatures might change, and the list is incomplete.
    // Probably just have a text area to put a function in
    hooks: {
        preAutocomplete: (searchString) => searchString,
        postAutocomplete: (searchString) => searchString,
        preSearch: (searchFilters) => searchFilters,
        postSearch: (searchResults) => searchResults,
    }
}